import { MinsterConfirmDialogComponent } from '../ui-components/minster-confirm-dialog/minster-confirm-dialog.component';
import { MinsterTextAreaComponent } from "../ui-components/minster-text-area/minster-text-area.component";
import { MinsterShowHideComponent } from "../ui-components/minster-show-hide/minster-show-hide.component";
import { MinsterCheckboxComponent } from "../ui-components/minster-checkbox/minster-checkbox.component";
import { MinsterAddressComponent } from "../ui-components/minster-address/minster-address.component";
import { MinsterSelectComponent } from "../ui-components/minster-select/minster-select.component";
import { ControlContainer, FormsModule, NgForm, NgModelGroup, Validators } from '@angular/forms';
import { MinsterInputComponent } from "../ui-components/minster-input/minster-input.component";
import { MinsterCardComponent } from "../ui-components/minster-card/minster-card.component";
import { LookUpServiceAndValidation } from '../../services/look-up-and-validation.service';
import { MinsterTelComponent } from '../ui-components/minster-tel/minster-tel.component';
import { ScreenBaseComponent } from '../screen-base/screen-base.component';
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { InputType, ScreenType } from '../../models/enums.models';
import { MatExpansionModule } from '@angular/material/expansion';
import { ClaimsService } from '../../services/claims.service';
import { DialogModel } from '../../models/dialog-model.model';
import { LookUp } from '../../models/look-up.model';
import { StateService } from '../../services/state.service';
import { ThirdPartyDetail } from '../../models/claim.model';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
    selector: 'app-responsible-party',
    standalone: true,
    imports: [MinsterCardComponent, FormsModule, MatButtonModule, MinsterCheckboxComponent, MinsterSelectComponent,
        MatExpansionModule, MinsterTextAreaComponent, MinsterInputComponent,
        MinsterShowHideComponent, MatIconModule, MinsterAddressComponent, MinsterTelComponent],
    templateUrl: './responsible-party.component.html',
    styleUrl: './responsible-party.component.css',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})

export class ResponsiblePartyComponent extends ScreenBaseComponent {
    @ViewChild(NgModelGroup) _formGroup: NgModelGroup | undefined;

    _thirdParty: ThirdPartyDetail;
    _obtainedThirdPartyDetails: LookUp[] = [];
    _inputTypes = InputType;
    _additionalThirdPartiesInvolved = false;
    _vehicleSpeed: LookUp[] = [];
    _telTypes: LookUp[] = [];
    _additionalThirdParties: ThirdPartyDetail[] = [];
    _readonly: boolean = false;
    _isThirdPartyVehicleInsuranceKnown: boolean = false;
    _personalDetailsNotKnown: boolean = false;

    constructor(
        stateService: StateService,
        claimService: ClaimsService,
        router: Router,
        toastr: ToastrService,
        private lookUpService: LookUpServiceAndValidation,
        private change: ChangeDetectorRef,
        private dialog: MatDialog
    ) {
        super(router, ScreenType.ResponsibleParty, toastr, stateService, claimService);

        this._thirdParty = stateService.claim!.thirdPartyDetails.find(x => x.isPrimary)!;
    }

    ngOnInit(): void {
        //Iniitalize contact so that fresh Creatio claims won't break the UI
        this.initializePrimaryContact();

        this._readonly = this.stateService.formIsSubmitted;
        this._additionalThirdPartiesInvolved = this.stateService.claim!.thirdPartyDetails.filter(x => x.isPrimary == false)?.length > 0;
        this._obtainedThirdPartyDetails = this.stateService.lookUps!.lookUpDictionary['ObtainedThirdPartyDetail'];
        this._vehicleSpeed = this.stateService.lookUps!.lookUpDictionary['VehicleSpeed'];
        this._telTypes = this.stateService.lookUps?.lookUpDictionary['TelephoneNumberType']!;
        this._additionalThirdParties = this.stateService.claim?.thirdPartyDetails.filter(x => !x.isPrimary) || [];
        this._isThirdPartyVehicleInsuranceKnown = this.stateService.claim?.isThirdPartyInsuranceKnown || false;
        this._personalDetailsNotKnown = !this._thirdParty.personalDetailsNotKnown;
        this.canYouGetTpDetails = this._thirdParty.canYouGetTpDetails || false;
    }

    ngAfterViewChecked(): void {
        this.updateValidators();
    }

    override isScreenValid(): boolean {
        return this.stateService.getFormValidationErrorsExcludeRequired(this._formGroup!.control) == 0;
    }

    get otherVehicles(): ThirdPartyDetail[] {
        return this.stateService.claim!.thirdPartyDetails.filter(x => x.isPrimary == false);
    }

    initializePrimaryContact(): void {
        if (this._thirdParty && (!this._thirdParty.thirdPartyContactDetails || this._thirdParty.thirdPartyContactDetails.length === 0)) {
            this._thirdParty.thirdPartyContactDetails = [
                {
                    thirdPartyContactDetailId: 0,
                    thirdPartyId: this._thirdParty.thirdPartyDetailId,
                    telephoneNumberTypeId: 1,
                    telephoneNumber: '',
                    isPrimary: true,
                    updatedBy: ''
                }
            ];
        }
    }

    createNewThirdPartyDetail(): ThirdPartyDetail {
        return {
            thirdPartyDetailId: 0,
            isPrimary: false,
            vehicleRegistrationNumber: '',
            thirdPartyDriverForename: '',
            thirdPartyDriverSurname: '',
            accordionOpen: true
        };
    }

    onLookUpRegistration(vrm: string): void {
        this.lookUpService.getVehicleDetails(vrm).subscribe({
            next: (result) => {
                this._thirdParty.vehicleMake = result.make;
                this._thirdParty.vehicleModel = result.model;
                this._thirdParty.vehicleColour = result.colour;
                this.change.markForCheck();
            },
            error: (e) => this.toastr.error('There was an error fetching the vehicle data, Please try again'),
        });
    }

    override onNext(): void {
        if (this._readonly) {
            super.onNext();
            return;
        }
        let hasErrors = false;
        this.updateValidators();

        if (this._formGroup && this._formGroup.invalid) {
            Object.keys(this._formGroup.control.controls).forEach((key) => {
                const control = this._formGroup!.control.get(key);
                if (control) {
                    const errors = control.errors;

                    if (errors) {
                        const hasOnlyRequiredError = Object.keys(errors).length === 1 && errors['required'];
                        if (this.stateService.formIsSubmitted || !hasOnlyRequiredError) {
                            hasErrors = true;
                        }
                    }

                    control.markAsTouched();
                    control.markAsDirty();
                    control.updateValueAndValidity();
                }
            });

            if (hasErrors) {
                this.toastr.warning('Please fix the form errors before proceeding.');
                this.stateService.enableSaving = false;
                return;
            }
        }

        if (this.stateService.formIsSubmitted && this._formGroup!.invalid) {
            this.toastr.warning('Please fix the required fields before proceeding.');
            this.stateService.enableSaving = false;
            return;
        }

        if (this._thirdParty?.thirdPartyContactDetails) {
            this._thirdParty.thirdPartyContactDetails = this._thirdParty.thirdPartyContactDetails.filter(contact =>
                contact.telephoneNumber?.trim() !== ""
            );
        }

        if (this._additionalThirdParties) {
            this._additionalThirdParties.forEach(thirdParty => {
                if (thirdParty.thirdPartyContactDetails) {
                    thirdParty.thirdPartyContactDetails = thirdParty.thirdPartyContactDetails.filter(contact =>
                        contact.telephoneNumber?.trim() !== ""
                    );
                }
            });
        }

        this.stateService.enableSaving = this.hasStateChanged();

        super.onNext();
    }

    //Primary Third Party
    get isRequired(): boolean {
        return this.stateService.formIsSubmitted;
    }

    get primaryTelephoneNumber(): string {
        return this._thirdParty?.thirdPartyContactDetails?.[0]?.telephoneNumber || '';
    }

    set primaryTelephoneNumber(value: string) {
        const thirdParty = this._thirdParty;
        if (thirdParty?.thirdPartyContactDetails?.[0]) {
            thirdParty.thirdPartyContactDetails[0].telephoneNumber = value;
            this.updatePrimaryStatus("primary-tp");
        }
    }

    get primaryPhoneType(): 'mobile' | 'landline' {
        const contact = this._thirdParty?.thirdPartyContactDetails?.[0];
        return contact?.telephoneNumberTypeId === 1 ? 'mobile' : 'landline';
    }

    set primaryPhoneType(value: 'mobile' | 'landline') {
        const thirdParty = this._thirdParty;
        if (thirdParty?.thirdPartyContactDetails?.[0]) {
            thirdParty.thirdPartyContactDetails[0].telephoneNumberTypeId = value === 'mobile' ? 1 : 2;
            this.updatePrimaryStatus("primary-tp");
        }
    }

    get primaryTelephoneTypeId(): number {
        return this._thirdParty?.thirdPartyContactDetails?.[0]?.telephoneNumberTypeId || 1;
    }

    set primaryTelephoneTypeId(value: number) {
        const thirdParty = this._thirdParty;
        if (thirdParty?.thirdPartyContactDetails?.[0]) {
            thirdParty.thirdPartyContactDetails[0].telephoneNumberTypeId = value;
            this.updatePrimaryStatus("primary-tp");
        }
    }

    get secondaryTelephoneNumber(): string {
        return this._thirdParty?.thirdPartyContactDetails?.[1]?.telephoneNumber || '';
    }

    set secondaryTelephoneNumber(value: string) {
        const thirdParty = this._thirdParty;
        if (thirdParty?.thirdPartyContactDetails?.[1]) {
            thirdParty.thirdPartyContactDetails[1].telephoneNumber = value;
            this.updatePrimaryStatus("primary-tp");
        }
    }

    get secondaryPhoneType(): 'mobile' | 'landline' {
        const contact = this._thirdParty?.thirdPartyContactDetails?.[1];
        return contact?.telephoneNumberTypeId === 1 ? 'mobile' : 'landline';
    }

    set secondaryPhoneType(value: 'mobile' | 'landline') {
        const thirdParty = this._thirdParty;
        if (thirdParty?.thirdPartyContactDetails?.[1]) {
            thirdParty.thirdPartyContactDetails[1].telephoneNumberTypeId = value === 'mobile' ? 1 : 2;
            this.updatePrimaryStatus("primary-tp");
        }
    }

    get secondaryTelephoneTypeId(): number {
        return this._thirdParty?.thirdPartyContactDetails?.[1]?.telephoneNumberTypeId || 0;
    }

    set secondaryTelephoneTypeId(value: number) {
        const thirdParty = this._thirdParty;
        if (thirdParty?.thirdPartyContactDetails?.[1]) {
            thirdParty.thirdPartyContactDetails[1].telephoneNumberTypeId = value;
            this.updatePrimaryStatus("primary-tp");
        }
    }

    get hasSecondaryPhone(): boolean {
        return (this._thirdParty?.thirdPartyContactDetails?.length || 0) > 1;
    }

    get canAddPhone(): boolean {
        const contactDetails = this._thirdParty?.thirdPartyContactDetails ?? [];
        return contactDetails.length < 2 && this.isPhoneNumberValid(contactDetails[0]?.telephoneNumber, contactDetails[0]?.telephoneNumberTypeId);
    }

    onRemoveAdditionalPhoneNumber(): void {
        if (this._thirdParty.thirdPartyContactDetails!.length > 1) {
            this._thirdParty.thirdPartyContactDetails!.splice(1, 1);
        }
        else {
            this.toastr.warning('You cannot remove the primary phone number.');
        }
    }

    onAddPhoneNumber(): void {
        if (!this._thirdParty.thirdPartyContactDetails || this._thirdParty.thirdPartyContactDetails.length === 0) {
            this._thirdParty.thirdPartyContactDetails = [
                {
                    thirdPartyContactDetailId: 0,
                    thirdPartyId: this._thirdParty.thirdPartyDetailId,
                    telephoneNumberTypeId: 1,
                    telephoneNumber: '',
                    isPrimary: true,
                    updatedBy: ''
                },
                {
                    thirdPartyContactDetailId: 0,
                    thirdPartyId: this._thirdParty.thirdPartyDetailId,
                    telephoneNumberTypeId: 2,
                    telephoneNumber: '',
                    isPrimary: true,
                    updatedBy: ''
                }
            ];

            return;
        }

        if (this._thirdParty.thirdPartyContactDetails.length >= 2) {
            this.toastr.warning('You can only add one additional phone number.');
            return;
        }

        //If there's already one number in, just add second phone number.
        this._thirdParty.thirdPartyContactDetails.push({
            thirdPartyContactDetailId: 0,
            thirdPartyId: this._thirdParty.thirdPartyDetailId,
            telephoneNumberTypeId: 2,
            telephoneNumber: '',
            isPrimary: false,
            updatedBy: ''
        });
    }

    //Owner
    onCommercialVehicle(): void {
        if (!this._thirdParty.isCommercialVehicle || this._thirdParty.isCommercialVehicle.length === 0) {
            if (!this._thirdParty.thirdPartyOwnerAddress) {
                this._thirdParty.thirdPartyOwnerAddress = {
                    addressId: 0,
                    typeId: 0,
                    companyName: '',
                    address1: '',
                    address2: '',
                    address3: '',
                    city: '',
                    county: '',
                    country: '',
                    postcode: ''
                };
            }
        }

        this.updateValidators();
    }

    //Additional Third Parties / Other Vehicles Section
    onRemoveAdditionalTp(vehicle: ThirdPartyDetail): void {
        const message = `Are you sure you want to delete the other vehicle ${vehicle.vehicleRegistrationNumber}?`;
        this.dialog
            .open(MinsterConfirmDialogComponent, {
                maxWidth: '600px',
                data: new DialogModel('Confirm Deletion', message)
            })
            .afterClosed()
            .subscribe((result) => {
                if (result) {
                    this.stateService.claim!.thirdPartyDetails = this.stateService.claim!.thirdPartyDetails.filter(
                        (x) => x !== vehicle
                    );
                    this._additionalThirdParties = this._additionalThirdParties.filter((x) => x !== vehicle);
                    this._additionalThirdPartiesInvolved = this._additionalThirdParties.length > 0;
                    this.change.markForCheck();
                }
            });
    }

    clearAdditionalTp(otherVehicleInvolved: boolean): void {
        if (!otherVehicleInvolved) {
            this._additionalThirdParties = [];
            this.stateService.claim!.thirdPartyDetails = this.stateService.claim!.thirdPartyDetails.filter(tp => tp.isPrimary);
        }
    }

    onAddAdditionalTp(): void {
        if (this._additionalThirdParties.length >= 10) {
            this.toastr.warning('You can only add up to 10 other vehicles.');
            return;
        }

        const newVehicle = this.createNewThirdPartyDetail();
        newVehicle.thirdPartyContactDetails = [
            {
                thirdPartyContactDetailId: 0,
                thirdPartyId: newVehicle.thirdPartyDetailId,
                telephoneNumberTypeId: 1,
                telephoneNumber: '',
                isPrimary: true,
                updatedBy: ''
            }
        ];

        this.stateService.claim!.thirdPartyDetails.push(newVehicle);
        this._additionalThirdParties.push(newVehicle);
        this.change.markForCheck();
    }

    //Additional Third Parties / Other Vehicles Contacts Section
    onRemoveAdditionalPhoneNumberAdditionalTp(ov: ThirdPartyDetail): void {
        if (ov.thirdPartyContactDetails!.length > 1) {
            ov.thirdPartyContactDetails!.splice(1, 1);
        }
        else {
            this.toastr.warning('You cannot remove the primary phone number.');
        }
    }

    onAddPhoneNumberAdditionalTp(ov: ThirdPartyDetail): void {
        if (!ov.thirdPartyContactDetails || ov.thirdPartyContactDetails.length === 0) {
            ov.thirdPartyContactDetails = [
                {
                    thirdPartyContactDetailId: 0,
                    thirdPartyId: ov.thirdPartyDetailId,
                    telephoneNumberTypeId: 1,
                    telephoneNumber: '',
                    isPrimary: true,
                    updatedBy: ''
                }
            ];

            return;
        }

        if (ov.thirdPartyContactDetails.length >= 2) {
            this.toastr.warning('You can only add one additional phone number.');
            return;
        }

        ov.thirdPartyContactDetails.push({
            thirdPartyContactDetailId: 0,
            thirdPartyId: ov.thirdPartyDetailId,
            telephoneNumberTypeId: 2,
            telephoneNumber: '',
            isPrimary: false,
            updatedBy: ''
        });
    }

    getPrimaryTelephoneNumber(index: number): string {
        return this._additionalThirdParties[index]?.thirdPartyContactDetails?.[0]?.telephoneNumber || '';
    }

    setPrimaryTelephoneNumber(index: number, value: string): void {
        const thirdParty = this._additionalThirdParties[index];

        if (thirdParty?.thirdPartyContactDetails?.[0]) {
            thirdParty.thirdPartyContactDetails[0].telephoneNumber = value;
            this.updatePrimaryStatus("additional-tp", index);
        }
    }

    getPrimaryPhoneType(index: number): 'mobile' | 'landline' {
        return this.getPrimaryTelephoneTypeId(index) === 1 ? 'mobile' : 'landline';
    }

    getPrimaryTelephoneTypeId(index: number): number {
        return this._additionalThirdParties[index]?.thirdPartyContactDetails?.[0]?.telephoneNumberTypeId || 1;
    }

    setPrimaryTelephoneTypeId(index: number, value: number): void {
        const thirdParty = this._additionalThirdParties[index];

        if (thirdParty?.thirdPartyContactDetails?.[0]) {
            thirdParty.thirdPartyContactDetails[0].telephoneNumberTypeId = value;
            this.updatePrimaryStatus("additional-tp", index);
        }
    }

    getSecondaryTelephoneNumber(index: number): string {
        return this._additionalThirdParties[index]?.thirdPartyContactDetails?.[1]?.telephoneNumber || '';
    }

    setSecondaryTelephoneNumber(index: number, value: string): void {
        const thirdParty = this._additionalThirdParties[index];

        if (thirdParty?.thirdPartyContactDetails?.[1]) {
            thirdParty.thirdPartyContactDetails[1].telephoneNumber = value;
            this.updatePrimaryStatus("additional-tp", index);
        }
    }

    getSecondaryPhoneType(index: number): 'mobile' | 'landline' {
        return this.getSecondaryTelephoneTypeId(index) === 1 ? 'mobile' : 'landline';
    }

    getSecondaryTelephoneTypeId(index: number): number {
        return this._additionalThirdParties[index]?.thirdPartyContactDetails?.[1]?.telephoneNumberTypeId || 1;
    }

    setSecondaryTelephoneTypeId(index: number, value: number): void {
        const thirdParty = this._additionalThirdParties[index];

        if (thirdParty?.thirdPartyContactDetails?.[1]) {
            thirdParty.thirdPartyContactDetails[1].telephoneNumberTypeId = value;
            this.updatePrimaryStatus("additional-tp", index);
        }
    }

    canAddPhoneAdditionalTp(index: number): boolean {
        const contactDetails = this._additionalThirdParties[index].thirdPartyContactDetails ?? [];
        return contactDetails.length < 2 && this.isPhoneNumberValid(contactDetails[0]?.telephoneNumber, contactDetails[0]?.telephoneNumberTypeId);
    }

    //Shared
    private updatePrimaryStatus(type: 'primary-tp' | 'additional-tp', index?: number): void {
        let contactDetails;

        if (type === 'primary-tp') {
            contactDetails = this._thirdParty?.thirdPartyContactDetails;
        }
        else if (type === 'additional-tp') {
            contactDetails = this._additionalThirdParties[index ?? 0]?.thirdPartyContactDetails;
        }

        if (!contactDetails) {
            return;
        }

        const primary = contactDetails[0];
        const secondary = contactDetails[1];

        if (primary) {
            primary.isPrimary = true;
        }

        if (secondary) {
            secondary.isPrimary = primary?.telephoneNumberTypeId !== secondary.telephoneNumberTypeId;
        }
    }

   get isThirdPartyVehicleInsuranceKnown(): boolean {
        return this._isThirdPartyVehicleInsuranceKnown;
    }

    set isThirdPartyVehicleInsuranceKnown(value: boolean) {
        this._isThirdPartyVehicleInsuranceKnown = value;
        if (this.stateService.claim) {
            this.stateService.claim.isThirdPartyInsuranceKnown = value;
        }
    }
        
    get canYouGetTpDetails(): boolean{
        return this._thirdParty.canYouGetTpDetails || false;
    }

    set canYouGetTpDetails(value: boolean) {
        this._thirdParty.canYouGetTpDetails = value;
    }

    get personalDetailsNotKnown(): boolean {
        return this._personalDetailsNotKnown;
    }

    set personalDetailsNotKnown(value: boolean) {
        this._personalDetailsNotKnown = value;
        this._thirdParty.personalDetailsNotKnown = !this._personalDetailsNotKnown;
    }

    private isPhoneNumberValid(phoneNumber: string, type: number): boolean {
        const phoneRegex = type === 1 ? /^07[0-9]{8,15}$/ : /^(?:01|02|03|08)[0-9]{8,15}$/;
        return phoneRegex.test(phoneNumber) && phoneNumber?.trim().length > 0;
    }

    updateValidators(): void {
        const controls = [
            { formName: this._fcn.ResponsibleParty.CanGetTpDetail, makeRequired: !this.personalDetailsNotKnown, resetValue: null },
            { formName: this._fcn.ResponsibleParty.ObtainedTpDetail, makeRequired: this.personalDetailsNotKnown, resetValue: null },
            { formName: this._fcn.ResponsibleParty.SecondaryPhoneNo, makeRequired: this.hasSecondaryPhone, resetValue: '' },
            { formName: this._fcn.ResponsibleParty.TpOwnerName, makeRequired: this._thirdParty.isCommercialVehicle, resetValue: '' },
            { formName: this._formNames.ResponsiblePartyOwnerAddress + '.third-party-owner-postcode', makeRequired: this._thirdParty.isCommercialVehicle, resetValue: '' },
            { formName: this._formNames.ResponsiblePartyOwnerAddress + '.third-party-owner-address-line-1', makeRequired: this._thirdParty.isCommercialVehicle, resetValue: '' },
            { formName: this._formNames.ResponsiblePartyOwnerAddress + '.third-party-owner-address-town', makeRequired: this._thirdParty.isCommercialVehicle, resetValue: '' },
            { formName: this._formNames.ResponsiblePartyOwnerAddress + '.third-party-owner-address-county', makeRequired: this._thirdParty.isCommercialVehicle, resetValue: '' },
            { formName: this._formNames.ResponsiblePartyOwnerAddress + '.third-party-owner-address-country', makeRequired: this._thirdParty.isCommercialVehicle, resetValue: undefined },
            { formName: this._fcn.ResponsibleParty.InsurerNameDetails, makeRequired: this.isThirdPartyVehicleInsuranceKnown, resetValue: '' }
        ];

        controls.forEach(({ formName, makeRequired, resetValue }) => {
            const control = this._formGroup?.control.get(formName);

            if (control) {
                if (makeRequired && !control.hasValidator(Validators.required)) {
                    control.setValidators([Validators.required]);
                }
                else if (!makeRequired && control.validator) {
                    control.clearValidators();
                    control.setValue(resetValue);
                }

                control.updateValueAndValidity();
            }
        });
    }
}
